export const CART_PAGE_URL = "/cart";
export const PRODUCTS_PAGE_URL = "/products";
export const COLLECTIONS_ALL_PAGE_URL = "/collections/all";
export const COLLECTIONS_PAGE_URL = "/collections";
export const LOGIN_PAGE_URL = "/account/login";
export const REGISTER_PAGE_URL = "/account/register";
